import React, {Component} from 'react';
import {Select} from 'antd';
import {connect} from 'react-redux';

import {getAccountSearch} from '@store/modules/core_account_search';

const { Option } = Select;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.dispatch(getAccountSearch());
    this.setState({
      value: this.props.value,
    });
  }

  componentWillReceiveProps(nextProps) {
    this.props.value !== nextProps.value && this.setState({ value: nextProps.value });
  }

  onChange = (value, options) => {
    this.setState({
      value,
    });
    this.props.onChange(value, options);
  };

  render() {
    const { value } = this.state;
    const { options, name } = this.props;
    return (
      <Select
        showSearch
        mode={this.props.isMultiple || ''}
        value={value}
        onChange={this.onChange}
        placeholder="人员"
        optionFilterProp="children"
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {value && name && !options.some(item => item.uuid === value) ? (
          <Option key={value} disabled>
            {name}(已禁用)
          </Option>
        ) : null}
        {options.map(item => (
          <Option key={item.uuid}>{item.name}</Option>
        ))}
      </Select>
    );
  }
}

export default connect(state => ({
  options: state.core_account_search,
}))(Index);



// WEBPACK FOOTER //
// ./src/components/comm/SearchUser.js